import React from 'react';
import { Section } from './ui/Section';
const steps = [{
  number: '01',
  title: 'Analyse & Zielbild',
  description: 'Wir verstehen Ihren Status Quo, identifizieren Engpässe und definieren klare Ziele für die Zusammenarbeit.'
}, {
  number: '02',
  title: 'Struktur & Systemdesign',
  description: 'Entwicklung der Prozesse, Auswahl der Tools und Design der zukünftigen Vertriebsarchitektur.'
}, {
  number: '03',
  title: 'Umsetzung & Enablement',
  description: 'Implementierung der Lösungen und Training Ihres Teams. Wir gehen erst, wenn es läuft.'
}, {
  number: '04',
  title: 'Skalierung & Optimierung',
  description: 'Laufende Messung der Ergebnisse und Feinjustierung für nachhaltiges Wachstum.'
}];
export function Process() {
  return <Section id="process" background="white" data-id="element-110">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-112">
          Unsere Vorgehensweise
        </h2>
        <p className="text-lg text-slate-600" data-id="element-113">
          Strukturiert, transparent und zielgerichtet zum Erfolg.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-114">
        {steps.map((step, index) => <div key={index} className="relative group" data-id="element-115">
            {/* Connector Line (Desktop only) */}
            {index < steps.length - 1 && <div className="hidden lg:block absolute top-8 left-1/2 w-full h-[1px] bg-slate-200 -z-10" data-id="element-116"></div>}

            <div className="bg-white p-6 border border-slate-100 rounded-sm hover:border-slate-300 transition-colors h-full" data-id="element-117">
              <div className="w-16 h-16 bg-slate-50 rounded-sm flex items-center justify-center text-2xl font-bold text-slate-300 mb-6 group-hover:bg-slate-900 group-hover:text-white transition-all duration-300" data-id="element-118">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-119">
                {step.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-120">
                {step.description}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}